<script setup>
import ZoomableImage from './ZoomableImage.vue';

defineProps({
    avatar: {
        type: String,
        required: true,
    },
});
</script>
<script>
export default {
    name: 'ZoomableAvatar',
};
</script>

<template>
    <ZoomableImage :src="avatar">
        <img class="hidden h-10 w-10 rounded-full sm:block" :src="avatar" alt="Avatar" />
    </ZoomableImage>
</template>
